export default __webpack_public_path__ + "static/media/report.9b35e341.png";